
const assistanceMentorCreate = [
    ["free", "filter.new.mentoringType.free"],
    ["paid", "filter.new.mentoringType.paid"]
];

export default assistanceMentorCreate;